import { caseActivityFormSchema } from "@/features/case-evaluation/types/activities";
import { caseRecordUserSchema } from "@/features/case-record/types/case-record-users";
import { caseRecordFormSchema } from "@/features/case-record/types/case-records";
import { z } from "zod";
import { calendarSchema } from "./calendar";

export const eventSchema = z.object({
	id: z.string(),
	calendar_id: z.string(),
	title: z.string(),
	type: z.string(),
	description: z.string(),
	location: z.string(),
	start: z.string(),
	end: z.string(),
	all_day: z.string(),
	status: z.string(),
	case_record_id: z.string().optional(),
	calendar: calendarSchema.optional(),
	caseRecord: caseRecordFormSchema.optional(),
	caseRecordUser: caseRecordUserSchema.optional(),
	caseActivity: caseActivityFormSchema.optional(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
});

export const eventSchemaDelete = z.object({
	id: z.string(),
	password: z.string().min(6, { message: "Required" }),
});

export type Event = z.infer<typeof eventSchema>;
export type EventDelete = z.infer<typeof eventSchemaDelete>;
